// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1Y1_N","imageUploader":"EGiftCard_imageUploader__184Zl"};